function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy90aWNrLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy90aWNrLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBUaWNrKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTEzLjUxIDIwLjQ3bDkuNzM3LTExLjEyOWExIDEgMCAwMTEuNTA2IDEuMzE4bC0xMC41IDEyYTEgMSAwIDAxLTEuNTE0LS4wMWwtNC41LTUuMjhBMSAxIDAgMDE5Ljc2IDE2LjA3bDMuNzQ5IDQuMzk5elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblRpY2sucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBUaWNrO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Tick(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M13.51 20.47l9.737-11.129a1 1 0 011.506 1.318l-10.5 12a1 1 0 01-1.514-.01l-4.5-5.28A1 1 0 019.76 16.07l3.749 4.399z",
    fill: primaryColor
  }));
}

Tick.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Tick;